import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { ApiUrlInjectionToken, CustomAccessory } from '@mitsubishi/shared/data-access';

@Injectable({
  providedIn: 'root',
})
export class AccessoryService {
  private readonly baseUrl: string;

  constructor(
    private http: HttpClient,
    @Inject(ApiUrlInjectionToken) apiServerUrl: string
  ) {
    this.baseUrl = apiServerUrl + '/project';
  }

  updateAccessoryQuantity(
    projectId: string,
    selectionId: string,
    accessoryId: string,
    quantity: number
  ): Observable<null> {
    return this.http.patch<null>(
      `${this.baseUrl}/${projectId}/selection/${selectionId}/unit/accessory/${accessoryId}/quantity`,
      { quantity: quantity }
    );
  }

  createAccessoryCustom(
    projectId: string,
    selectionId: string,
    unitId: string,
    accessoryCustom: CustomAccessory,
    isCustomUnit: boolean
  ) {
    return this.http.post<{ uuid: string }>(
      `${this.baseUrl}/${projectId}/selection/${selectionId}/unit/${unitId}/accessory-custom`,
      {
        ...accessoryCustom,
        isCustomUnit: isCustomUnit,
      }
    );
  }

  updateAccessoryCustom(
    projectId: string,
    selectionId: string,
    unitId: string,
    accessory: CustomAccessory,
    isCustomUnit: boolean
  ): Observable<null> {
    return this.http.put<null>(
      `${this.baseUrl}/${projectId}/selection/${selectionId}/unit/${unitId}/accessory-custom/${accessory.uuid}`,
      {
        ...accessory,
        isCustomUnit: isCustomUnit,
      }
    );
  }

  updatePrice(projectId: string, selectionId: string, accessoryId: string, price: number): Observable<null> {
    return this.http.patch<null>(
      `${this.baseUrl}/${projectId}/selection/${selectionId}/unit/accessory/${accessoryId}/price`,
      { priceList: price }
    );
  }

  deleteAccessoryCustom(
    projectId: string,
    selectionId: string,
    unitId: string,
    accessoryCustomId: string,
    isCustomUnit = false
  ): Observable<null> {
    const queryParams = {};
    if (isCustomUnit === true) {
      queryParams['isCustomUnit'] = true;
    }

    return this.http.delete<null>(
      `${this.baseUrl}/${projectId}/selection/${selectionId}/unit/${unitId}/accessory-custom/${accessoryCustomId}`,
      { params: queryParams }
    );
  }
}
